import {
  Workflow,
  Shield,
  Globe,
  Folder,
  Paperclip,
  Book,
  PersonStanding,
  HardDrive,
  Brain,
  Search,
  FileText,
  FileSpreadsheet,
  FileInput,
  ImagePlus,
  List,
  Eye,
  FlaskConical,
  Save,
  Trash2,
  RotateCcw,
  Cloud,
  Cog,
  Bot,
  Terminal,
  ListTodo,
  Clock,
  BookOpen,
  Send,
  SmilePlus,
  MessageSquare,
  User,
  Database,
  Presentation,
  FilePlus2,
  FileType,
  GraduationCap,
  Sparkles,
  SlidersHorizontal,
  Table2,
  Users,
  ArchiveRestore,
} from "lucide-react";

export const getIcon = (icon_name: string | undefined) => {
  switch (icon_name) {
    case "Globe":
      return <Globe width={16} height={16} />;
    case "Workflow":
      return <Workflow width={16} height={16} />;
    case "Folder":
      return <Folder width={16} height={16} />;
    case "Paperclip":
      return <Paperclip width={16} height={16} />;
    case "Book":
      return <Book width={16} height={16} />;
    case "PersonStanding":
      return <PersonStanding width={16} height={16} />;
    case "HardDrive":
      return <HardDrive width={16} height={16} />;
    case "Brain":
      return <Brain width={16} height={16} />;
    case "Search":
      return <Search width={16} height={16} />;
    case "FileText":
      return <FileText width={16} height={16} />;
    case "List":
      return <List width={16} height={16} />;
    case "Eye":
      return <Eye width={16} height={16} />;
    case "FlaskConical":
      return <FlaskConical width={16} height={16} />;
    case "Save":
      return <Save width={16} height={16} />;
    case "Trash2":
      return <Trash2 width={16} height={16} />;
    case "RotateCcw":
      return <RotateCcw width={16} height={16} />;
    case "Cloud":
      return <Cloud width={16} height={16} />;
    case "Cog":
      return <Cog width={16} height={16} />;
    case "Bot":
      return <Bot width={16} height={16} />;
    case "Terminal":
      return <Terminal width={16} height={16} />;
    case "ListTodo":
      return <ListTodo width={16} height={16} />;
    case "Clock":
      return <Clock width={16} height={16} />;
    case "BookOpen":
      return <BookOpen width={16} height={16} />;
    case "Shield":
      return <Shield width={16} height={16} />;
    case "Send":
      return <Send width={16} height={16} />;
    case "SmilePlus":
      return <SmilePlus width={16} height={16} />;
    case "MessageSquare":
      return <MessageSquare width={16} height={16} />;
    case "User":
      return <User width={16} height={16} />;
    case "FileSpreadsheet":
      return <FileSpreadsheet width={16} height={16} />;
    case "FileInput":
      return <FileInput width={16} height={16} />;
    case "ImagePlus":
      return <ImagePlus width={16} height={16} />;
    case "Database":
      return <Database width={16} height={16} />;
    case "Presentation":
      return <Presentation width={16} height={16} />;
    case "FilePlus2":
      return <FilePlus2 width={16} height={16} />;
    case "FileType":
      return <FileType width={16} height={16} />;
    case "GraduationCap":
      return <GraduationCap width={16} height={16} />;
    case "Sparkles":
      return <Sparkles width={16} height={16} />;
    case "SlidersHorizontal":
      return <SlidersHorizontal width={16} height={16} />;
    case "Table2":
      return <Table2 width={16} height={16} />;
    case "Users":
      return <Users width={16} height={16} />;
    // Agents saved before this tool was renamed carry the old string in their
    // stored entry; both map to the same glyph so an existing agent does not
    // silently fall through to the default below.
    case "PackageOpen":
    case "ArchiveRestore":
      return <ArchiveRestore width={16} height={16} />;
    default:
      return <Workflow width={16} height={16} />;
  }
};
